<!-- Header -->
<div mat-dialog-title style="margin: 0px" translate>Report Folders</div>

<!-- Content -->
<mat-dialog-content>

    <div translate>Include <span style="font-weight:bold;">{{selectedReport.Name}}</span> in the
        following folders:</div>
    <table style="margin-left:10px; width:95%;">
        <tr>
            <td width="50px" style="padding: 5px">
                <mat-checkbox [(ngModel)]="foldersChkAll" (ngModelChange)="checkAllFolders(foldersChkAll)">
                </mat-checkbox>
                <!-- <tyl-checkbox 
                    [(checked)]="foldersChkAll" 
                    (change)="checkAllFolders(foldersChkAll)" 
                    id="checkAllFolders_ID"
                    name="checkAllFolders(foldersChkAll)">
                </tyl-checkbox> -->
            </td>
            <td width="150px" style="font-weight:bold; padding: 5px">
                Folder
            </td>
            <td style="width:200px; font-weight:bold; padding: 5px">
                Description
            </td>
        </tr>
        <tr *ngFor="let Folder of reportFolders">
            <!-- ngClass="{'tableOddRow': !isEven($index +1), 'tableEvenRow': isEven($index +1)}"
            st-select-row="Report" st-select-mode="single">-->
            <td align="center" style="padding: 5px">
                <mat-checkbox [(ngModel)]="Folder.ReportInFolder" (ngModelChange)="chkFolder(Folder)"></mat-checkbox>
            </td>
            <td style="line-height:normal; padding: 5px">
                {{Folder.Name}}
            </td>
            <td style="padding: 5px">
                {{Folder.Description}}
            </td>
        </tr>
    </table>

    <!-- Auto-Run Settings -->
    <!-- <div *ngIf="allowAutoRunReport">
        <div style=padding-top:20px;></div>
        <h4 style="padding:10px;" [ngStyle]="{color: allowAutoRunReport ? 'black' : 'lightgray'}">Auto-Run Settings</h4>
        <table style="width:95%; margin-left:10px;">
            <tr>
                <td colspan="2">
                    <tyl-checkbox [(checked)]="selectedReport.AutoRunReport" (change)="autoRunReportClick()" id="cbAutoRunReport_ID"
                        name="cbAutoRunReport" [ngStyle]="{color: allowAutoRunReport ? 'black' : 'lightgray'}"
                        [disabled]="noFolderSelected || (!allowAutoRunReport)">
                        Auto-run report
                    </tyl-checkbox>
                    <div [ngStyle]="{color: allowAutoRunReport ? 'black' : 'lightgray'}">
                        Maximum Snapshots is set to {{MaximumSnapshots}}
                    </div>
                </td>
            </tr> -->

    <!-- ONCE A WEEK-->
    <!-- <tr [ngStyle]="{color: selectedReport.AutoRunReport == false ? 'lightgray' : 'black'}">
                <td align="center">
                    <input type="radio" name="frequency" [disabled]="!selectedReport.AutoRunReport" [checked]="selectedReport.AutoRunFrequency == 0"
                        (click)="setFrequency(0)" />
                    Once a Week
                </td>
                <td>

                    <tyl-form-field label="Day">

                        <mat-select id="ddlAutoRunDay" name="ddlAutoRunDay" [(ngModel)]="selectedReport.AutoRunDay"
                            [(value)]="selectedReport.AutoRunDay" [disabled]="!selectedReport.AutoRunReport || selectedReport.AutoRunFrequency != 0"
                            [required]="selectedReport.AutoRunReport && selectedReport.AutoRunFrequency == 0">
                            <mat-option value="MON">Monday</mat-option>
                            <mat-option value="TUE">Tuesday</mat-option>
                            <mat-option value="WED">Wednesday</mat-option>
                            <mat-option value="THU">Thursday</mat-option>
                            <mat-option value="FRI">Friday</mat-option>
                            <mat-option value="SAT">Saturday</mat-option>
                            <mat-option value="SUN">Sunday</mat-option>
                        </mat-select>

                    </tyl-form-field>

                    <tyl-form-field label="Time">

                        <input matInput [(ngModel)]="selectedReport.AutoRunTime" placeholder="hh:mm" [disabled]="!selectedReport.AutoRunReport || selectedReport.AutoRunFrequency != 0"
                            [required]="selectedReport.AutoRunReport && selectedReport.AutoRunFrequency == 0" />

                    </tyl-form-field>

                </td>
            </tr> -->

    <!-- ONCE A DAY-->
    <!-- <tr [ngStyle]="{color: selectedReport.AutoRunReport == false ? 'lightgray' : 'black'}">
                <td align="center">
                    <input type="radio" name="frequency" [disabled]="!selectedReport.AutoRunReport" [checked]="selectedReport.AutoRunFrequency == 1"
                        (click)="setFrequency(1)" />
                    Once a day
                </td>
                <td>
                    <tyl-form-field label="Time">
                        <input matInput [(ngModel)]="selectedReport.AutoRunTime" placeholder="hh:mm" [disabled]="!selectedReport.AutoRunReport || selectedReport.AutoRunFrequency != 1"
                            [required]="selectedReport.AutoRunReport && selectedReport.AutoRunFrequency == 1" />
                    </tyl-form-field>
                </td>
            </tr> -->

    <!-- ONCE -->
    <!-- <tr [ngStyle]="{color: selectedReport.AutoRunReport == false ? 'lightgray' : 'black'}">
                <td align="center">
                    <input type="radio" name="frequency" [disabled]="!selectedReport.AutoRunReport" [checked]="selectedReport.AutoRunFrequency == 2"
                        (click)="setFrequency(2)" />
                    Once
                </td>
                <td>
                    <ng-container style="display:inline;">
                        <tyl-datepicker label="Date" id="OnceDatePicker" [(value)]="selectedReport.AutoRunDate"
                            [disabled]="!selectedReport.AutoRunReport || selectedReport.AutoRunFrequency != 2">
                        </tyl-datepicker>
                    </ng-container>

                    <tyl-form-field label="Time">

                        <input matInput [(ngModel)]="selectedReport.AutoRunTime" placeholder="hh:mm" [disabled]="!selectedReport.AutoRunReport || selectedReport.AutoRunFrequency != 2"
                            [required]="selectedReport.AutoRunReport && selectedReport.AutoRunFrequency == 2" />

                    </tyl-form-field>

                </td>
            </tr>
            <tr [ngStyle]="{color: selectedReport.AutoRunReport == false ? 'lightgray' : 'black'}">
                <td colspan="2">
                    <a style="font-size:10pt;cursor:pointer;" (click)="openAutorunDefaultParametersDialog()">
                        <span>Select Autorun Default Parameters</span>
                    </a>
                </td>
            </tr>
        </table> -->

    <!-- <reportParameters></reportParameters> -->
    <!-- </div> -->

</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button *ngIf="this.inDebugMode" style="float:right; color: black;" image="next arrow.png"
            label="Selected Report To Console" (clickEvent)="SelectedReportToConsole()"></tyl-button>
        <tyl-button style="float:right; color: black;" image="save.png" translate label="Save"
            (clickEvent)="saveClick()"></tyl-button>
        <tyl-button style="float:right; color: black;" image="cancel.png" translate label="Cancel"
            (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>